import ReactDOM from "react-dom";
import "./styles/tailwind.css";
import "./styles/style.css";
import "../assets/css/wine.css";
import App from "./App";
export * from "./blocks";

const rootElement = document.getElementById("root");
if (rootElement) {
	ReactDOM.render(<App />, document.getElementById("root"));
}
